import React from "react";
import { post } from "../../../controlers/global/ConfigRequest";
import { LOGIN_ADDRESS, SEND_OTP } from "../../../helperData/ApiAddress";
import { GlobalStateContext } from "../../../layouts/GlobalStates";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { normalizeFaNumbers } from "../../../utils/methods";
import {
    applyTokenResponse,
    getLoginErrorMessage,
    resolvePostLoginPath,
} from "../../../helperData/panelRoutes";
import {
    getPostLoginFlavor,
    readStoredAppFlavor,
    persistAppFlavor,
} from "../../../helperData/appFlavor";

export default function Login({ mode, setMode, phoneInit, setActiveTab }) {
    const { t } = useTranslation();
    // const [showForget, setShowForget] = React.useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [username, setUsername] = React.useState("");
    const [usernameErr, setUsernameErr] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [passwordErr, setPasswordErr] = React.useState("");
    const [rememberMe, setRememberMe] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [resultErr, setResultErr] = React.useState("");
    const [phone, setPhone] = React.useState(phoneInit || "");
    const [phoneErr, setPhoneErr] = React.useState("");
    const [code, setCode] = React.useState("****");
    const [otpTimer, setOtpTimer] = React.useState(0);
    const { setAuth, setRefreshNewCount, setCurrentPanel } =
        React.useContext(GlobalStateContext);
    const [newPassword, setNewPassword] = React.useState();
    const [reNewPassword, setReNewPassword] = React.useState();
    const [newPasswordErr, setNewPasswordErr] = React.useState();
    const [matchPassErr, setMatchPassErr] = React.useState();

    React.useEffect(() => {
        // setPhone(phoneInit);
        // console.log("fgfgfg0)");
        if (phone && mode === 3) sendOTPHandle();
    }, []);

    React.useEffect(() => {
        setResultErr("");
    }, [mode]);

    const otpUsernameHandle = (e) => {
        var patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setUsernameErr("");
            setUsername(e.target.value);
        }
    };

    const usernameHandle = (e) => {
        setUsernameErr("");
        setUsername(e.target.value);
    };

    const passwordHandle = (e) => {
        setPasswordErr("");
        setPassword(e.target.value);
    };

    const rememberMeHandle = () => {
        setRememberMe(!rememberMe);
    };

    const finishLogin = (user) => {
        const returnPath =
            location.state?.from ||
            (location.pathname.startsWith("/feedback")
                ? `${location.pathname}${location.search}`
                : null);
        const flavor = getPostLoginFlavor(user, readStoredAppFlavor());
        persistAppFlavor(flavor);
        setCurrentPanel(flavor);
        navigate(resolvePostLoginPath(user, returnPath, flavor), {
            replace: true,
        });
    };

    const otpLoginHandle = () => {
        let hasErr = false;
        let phoneStr;
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                hasErr = true;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                hasErr = true;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(t("Src.Component.Global.AuthModal.Login.setPhoneErr"));
            hasErr = true;
        }

        if (hasErr) return false;
        setLoading(true);
        setResultErr("");
        post(LOGIN_ADDRESS, {
            username: phoneStr,
            password: code,
            grant_type: "password",
        })
            .then((r) => {
                applyTokenResponse(setAuth, r);
                if (!rememberMe) {
                    window.localStorage.removeItem("refresh_token");
                }
                setRefreshNewCount((prevState) => !prevState);
                setLoading(false);
                finishLogin(r.user);
            })
            .catch((error) => {
                setLoading(false);
                setResultErr(
                    getLoginErrorMessage(
                        error,
                        t("Src.Component.Global.AuthModal.Login.setResultCodeErr")
                    )
                );
            });
    };

    const loginHandle = () => {
        let hasErr = false;
        let phoneStr;
        const normalizedUsername = username.trim();

        if (
            normalizedUsername[0] === "0" &&
            normalizedUsername[1] === "9"
        ) {
            phoneStr = "+98" + normalizedUsername.substr(1);
        }

        if (normalizedUsername.length === 0) {
            setUsernameErr(
                t("Src.Component.Global.AuthModal.Login.setUsernameErr")
            );
            hasErr = true;
        }
        if (password.trim().length === 0) {
            setPasswordErr(
                t("Src.Component.Global.AuthModal.Login.setPasswordErr")
            );
            hasErr = true;
        }
        if (hasErr) return false;
        setLoading(true);
        setResultErr("");
        post(LOGIN_ADDRESS, {
            username: phoneStr || normalizedUsername,
            password: password.trim(),
            grant_type: "password",
        })
            .then((r) => {
                applyTokenResponse(setAuth, r);
                if (!rememberMe) {
                    window.localStorage.removeItem("refresh_token");
                }
                setRefreshNewCount((prevState) => !prevState);
                setLoading(false);
                finishLogin(r.user);
            })
            .catch((error) => {
                setLoading(false);
                setResultErr(
                    getLoginErrorMessage(
                        error,
                        t("Src.Component.Global.AuthModal.Login.setResultErr")
                    )
                );
            });
    };

    const codeTabHandle = (e) => {
        if (e.which === 8 && e.target.value === "") {
            e.target.previousElementSibling?.focus();
            e.target.previousElementSibling?.select();
        } else if (e.target.value.length === 1) {
            e.target.nextElementSibling?.focus();
            e.target.nextElementSibling?.select();
        }
    };
    const codeValueHandle = (e, index) => {
        let temp = [...code];

        if (e.target.value.length === 1) {
            temp[index] = normalizeFaNumbers(e.target.value);
        }
        if (e.target.value.length === 0) {
            temp[index] = "*";
        }
        setCode(temp.join(""));
    };

    const phoneHandle = (e) => {
        let patt = new RegExp(/^\+?([0-9]*)$/);
        if (patt.test(e.target.value) || e.target.value === "") {
            setPhoneErr("");
            setPhone(e.target.value);
        }
    };

    const sendOTPHandle = (e) => {
        let phoneStr;
        if (phone[0] === "+") {
            phoneStr = phone;
        } else if (phone[0] === "0") {
            if (phone[1] !== "9") {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                return false;
            }
            if (phone.length !== 11) {
                setPhoneErr(
                    t("Src.Component.Global.AuthModal.Login.setPhoneErr")
                );
                return false;
            }
            phoneStr = "+98" + phone.substr(1);
        } else {
            setPhoneErr(t("Src.Component.Global.AuthModal.Login.setPhoneErr"));
            return false;
        }
        setOtpTimer(120);
        setResultErr("");
        post(SEND_OTP, { phone_number: phoneStr }).catch(() => {
            setResultErr(
                t("Src.Component.Global.AuthModal.Login.setResultCodeErr")
            );
        });
    };

    React.useEffect(() => {
        if (otpTimer > 0)
            var timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
        return () => {
            clearTimeout(timer);
        };
    }, [otpTimer]);

    return (
        <div className="auth-scroll-body">
            {mode !== 2 && mode !== 3 && (
                <div>
                    <div className="login-container">
                        <div className="input-form">
                            <div className="ri-input">
                                <label>{t("Username.Place.Holder")}</label>
                                <input
                                    type="text"
                                    placeholder={t(
                                        "Username.Hint.Place.Holder"
                                    )}
                                    value={username}
                                    onChange={usernameHandle}
                                    style={{
                                        borderColor: usernameErr && "orange",
                                    }}
                                />
                                {usernameErr && (
                                    <div className="login-form-err">
                                        {usernameErr}
                                    </div>
                                )}
                            </div>
                            <div className="ri-input">
                                <label>{t("Password.Place.Holder")}</label>
                                <input
                                    type="password"
                                    placeholder={t(
                                        "Password.Hint.Place.Holder"
                                    )}
                                    value={password}
                                    onChange={passwordHandle}
                                    style={{
                                        borderColor: passwordErr && "orange",
                                    }}
                                    onKeyUp={(e) =>
                                        e.which === 13 && loginHandle()
                                    }
                                />
                                {passwordErr && (
                                    <div className="login-form-err">
                                        {passwordErr}
                                    </div>
                                )}
                            </div>
                            <div className="check_btn login-check">
                                <label class="check-container">
                                    {t("RememberMe.Label")}
                                    <input
                                        type="checkbox"
                                        onChange={rememberMeHandle}
                                        checked={rememberMe}
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <div className="forget-section">
                                <div onClick={() => setMode(2)}>
                                    {t("LogInWithCode.Button")} /{" "}
                                    {t("ForgotYourPassword.Button")}
                                </div>
                            </div>
                            <div className="change-password-section">
                                <div onClick={() => setActiveTab(2)}>
                                    {t("ChangePassword.Button")}
                                </div>
                            </div>
                        </div>
                        <div className="ri-btn">
                            <button className="btn-st-1" onClick={loginHandle}>
                                {t("LogIn.Button")}
                            </button>
                            {loading && (
                                <div className="login-form-notif">
                                    {t("Login.Loading")}
                                </div>
                            )}
                            {resultErr && (
                                <div className="login-form-err">
                                    {resultErr}
                                </div>
                            )}
                            {/* <button onClick={handleClose} className="btn-st-2"><Google />ورود از طریق گوگل</button> */}
                        </div>
                    </div>
                </div>
            )}

            {(mode === 2 || mode === 3) && (
                <div>
                    <div className="forget-container">
                        <div className="input-form" style={{ marginBottom: 0 }}>
                            <div className="send-code-section">
                                <div className="ri-input">
                                    <label>
                                        {t("PhoneNumber.Place.Holder")}
                                    </label>
                                    <input
                                        type="tel"
                                        placeholder={t(
                                            "PhoneNumber.Hint.Place.Holder"
                                        )}
                                        value={phone}
                                        onChange={phoneHandle}
                                        readOnly={mode === 3}
                                        style={{
                                            borderColor: phoneErr && "orange",
                                            width: "100%",
                                        }}
                                    />
                                    {phoneErr && (
                                        <div
                                            className="login-form-err"
                                            style={{ height: 0, margin: 0 }}
                                        >
                                            {phoneErr}
                                        </div>
                                    )}
                                </div>
                                {mode === 2 && (
                                    <div>
                                        <button
                                            className="send-btn"
                                            disabled={otpTimer > 0}
                                            onClick={sendOTPHandle}
                                        >
                                            {otpTimer > 0
                                                ? otpTimer +
                                                  `${t(
                                                      "SendCode.Time.Button"
                                                  )} `
                                                : t("SendCode.Button")}
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="forget-numbers" dir="ltr">
                                <input
                                    type="tel"
                                    onKeyUp={codeTabHandle}
                                    value={code[0] === "*" ? "" : code[0]}
                                    onChange={(e) => codeValueHandle(e, 0)}
                                    placeholder="1"
                                />
                                <input
                                    type="tel"
                                    onKeyUp={codeTabHandle}
                                    value={code[1] === "*" ? "" : code[1]}
                                    onChange={(e) => codeValueHandle(e, 1)}
                                    placeholder="2"
                                />
                                <input
                                    type="tel"
                                    onKeyUp={codeTabHandle}
                                    value={code[2] === "*" ? "" : code[2]}
                                    onChange={(e) => codeValueHandle(e, 2)}
                                    placeholder="3"
                                />
                                <input
                                    type="tel"
                                    onKeyUp={codeTabHandle}
                                    value={code[3] === "*" ? "" : code[3]}
                                    onChange={(e) => codeValueHandle(e, 3)}
                                    placeholder="4"
                                />
                            </div>
                            <div
                                className="check_btn login-check"
                                style={{ marginTop: 50 }}
                            >
                                {mode !== 4 && (
                                    <label class="check-container">
                                        {t("RememberMe.Label")}
                                        <input
                                            type="checkbox"
                                            onChange={rememberMeHandle}
                                            checked={rememberMe}
                                        />
                                        <span class="checkmark"></span>
                                    </label>
                                )}
                            </div>
                        </div>
                        <div className="ri-btn">
                            <button
                                className="btn-st-1"
                                onClick={otpLoginHandle}
                            >
                                {t("LogIn.Button")}
                            </button>
                            {mode === 2 && (
                                <button
                                    onClick={() => setMode(1)}
                                    className="btn-st-2"
                                >
                                    {t("SendCode.Back.Button")}
                                </button>
                            )}
                            {loading && (
                                <div className="login-form-notif">
                                    {t("Login.Loading")}
                                </div>
                            )}
                            {resultErr && (
                                <div className="login-form-err">
                                    {resultErr}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
